import type { Message } from '../types';

interface SystemMessageCardProps {
  message: Message;
}

const cardStyle: React.CSSProperties = {
  background: '#f7f9fc',
  border: '1px solid #e3e8ef',
  borderRadius: 8,
  padding: '8px 12px',
  margin: '4px auto',
  maxWidth: 460,
  fontSize: 13,
  color: '#3b4252',
};

const labelStyle: React.CSSProperties = {
  fontWeight: 600,
  textTransform: 'uppercase',
  fontSize: 11,
  color: '#5e6c84',
  letterSpacing: 0.4,
  marginBottom: 2,
};

function eventLabel(eventType: string | undefined): string {
  if (!eventType) return 'System';
  return eventType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function SystemMessageCard({ message }: SystemMessageCardProps) {
  const eventType =
    (message.metadata?.event_type as string | undefined) ?? null;
  return (
    <div style={cardStyle}>
      <div style={labelStyle}>{eventLabel(eventType ?? undefined)}</div>
      <div>{message.content || ''}</div>
    </div>
  );
}
